export type ComponentCatalogRouteParams = {
    slug?: string;
};

export type ComponentCatalogEntry = {
    slug: string;
    label: string;
    description: string;
};

export const COMPONENT_CATALOG_REGISTRY = [
    {
        slug: "button",
        label: "Button",
        description: "Component for rendering a button.",
    },
    {
        slug: "avatar",
        label: "Avatar",
        description: "User avatar with image, initials, or icon fallback.",
    },
    {
        slug: "badge",
        label: "Badge",
        description: "Compact numeric badge for counts and alerts.",
    },
    {
        slug: "breadcrumb",
        label: "Breadcrumb",
        description: "Navigational breadcrumb trail.",
    },
    {
        slug: "checkbox",
        label: "Checkbox",
        description: "Single checkbox with label and visual states.",
    },
    {
        slug: "dialog-box",
        label: "DialogBox",
        description: "Accessible modal dialog with actions.",
    },
    {
        slug: "divider",
        label: "Divider",
        description: "Horizontal or vertical divider line.",
    },
    {
        slug: "flags",
        label: "Flags",
        description: "Country flag display with size and shape options.",
    },
    {
        slug: "header",
        label: "Header",
        description: "Top-level menu header with LinkType items.",
    },
    {
        slug: "icon",
        label: "Icon",
        description: "Icon renderer for base, file, and social assets.",
    },
    {
        slug: "kpi-board",
        label: "KPIBoard",
        description: "KPI tile board with trend and sparkbar support.",
    },
    {
        slug: "link-type",
        label: "LinkType",
        description: "Link-style action with variants and states.",
    },
    {
        slug: "media-block",
        label: "MediaBlock",
        description: "Image or empty media block aspect ratio preview.",
    },
    {
        slug: "radio-button",
        label: "RadioButton",
        description: "Radio group for single selection.",
    },
    {
        slug: "select-button",
        label: "SelectButton",
        description: "Segmented button group with text and icon options.",
    },
    {
        slug: "status",
        label: "Status",
        description: "Status indicator with icon and optional label.",
    },
    {
        slug: "tabs",
        label: "Tabs",
        description: "Tab navigation and panel preview.",
    },
    {
        slug: "tag",
        label: "Tag",
        description: "Categorical tag with prefix and suffix options.",
    },
    {
        slug: "task-board",
        label: "TaskBoard",
        description: "Kanban-style task board grouped by status.",
    },
    {
        slug: "task-pane",
        label: "TaskPane",
        description: "Task details pane with footer actions.",
    },
    {
        slug: "toggle-switch",
        label: "ToggleSwitch",
        description: "Binary toggle with optional label.",
    },
    {
        slug: "tooltip",
        label: "Tooltip",
        description: "Tooltip preview attached to a target element.",
    },
    {
        slug: "tree-select",
        label: "TreeSelect",
        description: "Hierarchical tree select control.",
    },
    {
        slug: "app-footer",
        label: "AppFooter",
        description: "Application footer bar with support link and version.",
    },
    {
        slug: "left-menu",
        label: "LeftMenu",
        description: "Vertical app switcher rail.",
    },
    {
        slug: "nav-header",
        label: "NavHeader",
        description: "Secondary navigation bar with utility tabs.",
    },
    {
        slug: "tab-add-menu",
        label: "TabAddMenu",
        description: "Context menu opened from the plus button.",
    },
    {
        slug: "nav-link",
        label: "NavLink",
        description: "Hierarchical navigation links with optional badges and icons.",
    },
    {
        slug: "nav-panel",
        label: "NavPanel",
        description: "Sidebar panel with header, content area, and optional footer actions.",
    },
    {
        slug: "nav-tree",
        label: "NavTree",
        description: "Composed navigation tree with filtering and optional select tree mode.",
    },
    {
        slug: "popover",
        label: "Popover",
        description: "Overlay panel anchored to a trigger element.",
    },
    {
        slug: "search",
        label: "Search",
        description: "Search input with selection and optional filter behaviors.",
    },
    {
        slug: "accordion",
        label: "Accordion",
        description: "Collapsible content sections with optional icons and actions.",
    },
    {
        slug: "ai-panel",
        label: "AiPanel",
        description: "AI-powered panel for contextual assistance and insights.",
    },
    {
        slug: "dropdown",
        label: "Dropdown",
        description: "Selectable menu list with single or multiple options.",
    },
    {
        slug: "notification-panel",
        label: "Notification Panel",
        description: "Panel displaying notifications, alerts, and updates.",
    },
    {
        slug: "primary-header",
        label: "Primary Header",
        description: "Main application header with branding and navigation.",
    },
    {
        slug: "secondary-header",
        label: "Secondary Header",
        description: "Supplementary header for contextual actions and navigation.",
    },
    {
        slug: "utility-panel",
        label: "Utility Panel",
        description: "Side panel providing quick access to tools and utilities.",
    },
    {
        slug: "card",
        label: "Card",
        description: "Container for grouping related content and actions.",
    },
    {
        slug: "carousel",
        label: "Carousel",
        description: "Scrollable collection of content items or images.",
    },
    {
        slug: "contact-card",
        label: "Contact Card",
        description: "Compact display of contact information and actions.",
    },
    {
        slug: "date-picker",
        label: "Date Picker",
        description: "Calendar input for selecting dates and ranges.",
    },
    {
        slug: "download-card",
        label: "Download Card",
        description: "Card component for downloadable files and resources.",
    },
    {
        slug: "file-upload",
        label: "File Upload",
        description: "Input control for uploading files and attachments.",
    },
    {
        slug: "footer",
        label: "Footer",
        description: "Bottom section containing links, information, and actions.",
    },
    {
        slug: "input-field",
        label: "Input Field",
        description: "Text input control for user-entered data.",
    },
    {
        slug: "link-list",
        label: "Link List",
        description: "Collection of navigational or resource links.",
    },
    {
        slug: "list",
        label: "List",
        description: "Structured display of items with optional interactions.",
    },
    {
        slug: "loading-spinner",
        label: "Loading Spinner",
        description: "Visual indicator for loading and processing states.",
    },
    {
        slug: "modal",
        label: "Modal",
        description: "Overlay dialog used for focused interactions and confirmations.",
    },
    {
        slug: "notification",
        label: "Notification",
        description: "Transient message used to inform users of events or actions.",
    },
    {
        slug: "pagination",
        label: "Pagination",
        description: "Navigation control for traversing paged content.",
    },
    {
        slug: "progress-indicator",
        label: "Progress Indicator",
        description: "Visual representation of task completion progress.",
    },
    {
        slug: "user-settings",
        label: "User Settings",
        description: "Interface for viewing and managing user preferences.",
    },
    {
        slug: "skeleton",
        label: "Skeleton",
        description: "Placeholder UI for loading content.",
    },
    {
        slug: "stepper",
        label: "Stepper",
        description: "Component for guiding users through a multi-step process.",
    },
    {
        slug: "drawer",
        label: "Drawer",
        description: "Slide-in panel for additional content or navigation.",
    },
    {
        slug: "sidebar",
        label: "Sidebar",
        description: "Vertical navigation panel for application sections.",
    }
] as const satisfies readonly ComponentCatalogEntry[];

export type ComponentCatalogSlug =
    (typeof COMPONENT_CATALOG_REGISTRY)[number]["slug"];

export const COMPONENT_BASE_PATH = "/ui-template";